import { axiosInstance } from '../../../shared/api';

export async function singUpRequest(userData) {
	try {
		const { data } = await axiosInstance.post('auth/register', userData);
		return data;
	} catch (error) {
		return error;
	}
}
